// GOSH DARN UPGRADES THAT BREAK SHIT! Here's more info on moving from FB8 to FB9
//    https://firebase.google.com/docs/web/modular-upgrade
// Here's a good tutorial from net ninja:
//    https://www.youtube.com/watch?v=9zdvmgGsww0&list=PL4cUxeGkcC9jERUGvbudErNCeSZHWUVlb
// A good reference with examples:
//    https://www.codegrepper.com/code-examples/javascript/firestore+v9+addDoc+and+setDoc+collection%28%29+doc%28%29

// becareful with .exists (for snapshots), it's now a method: exists()

import { initializeApp } from "firebase/app"
import { getFirestore, collection, query, where, getDocs, getDoc, doc, addDoc, setDoc, orderBy, Timestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signOut, GoogleAuthProvider, EmailAuthProvider, signInWithEmailAndPassword } from "firebase/auth";

// imports for the auth UI
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
const googleProviderId = new GoogleAuthProvider().providerId;
const emailProviderId = new EmailAuthProvider().providerId;

const firebaseConfig = {
  apiKey: "AIzaSyA8FVbjyqeSBEHb6eH-Q0UZtcTcp6Gv2ms",
  authDomain: "headcheck-57612.firebaseapp.com",
  projectId: "headcheck-57612",
  storageBucket: "headcheck-57612.appspot.com",
  messagingSenderId: "608979717958",
  appId: "1:608979717958:web:edde38520bcb0b384a9f47"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);


function getUserDocument(user){
  const docRef = doc(db, "users", user.uid);
  return getDoc(docRef)
}

function createUserDocumentWithIdAndEmail(userId, userEmail){
  const data =  {email: userEmail};
  const docRef = doc(db,"users", userId);
  return setDoc(docRef, data); // if you have an id for the doc (in this case the user id), then use setDoc instead of addDoc
}

function getThoughtsForUser(userId, startDate, endDate){
 
  let q = query(collection(db, `users/${userId}/thoughts`), orderBy("date","desc"));

  if(startDate && endDate){
    q = query(q, where("date", ">=", startDate), where("date", "<=", endDate))
  }
  // resource on mulitple where clauses: https://stackoverflow.com/questions/69875064/firebase-version-9-using-multiple-conditional-where-clauses
  
  return getDocs(q).then(snapshot => {
    const thoughts = [];
    snapshot.forEach(doc => {
        // convert fb timestamp to js date
        const date = doc.data().date.toDate()                   
        thoughts.push({...doc.data(), id:doc.id, date});
    })
    return thoughts;
  });
}

async function insertThought(userId, thoughtObj){
  let collRef = await collection(db, `users/${userId}/thoughts`);
  return addDoc(collRef, thoughtObj);
}

function getThought(userId, thoughtId){
  const docRef = doc(db, `users/${userId}/thoughts/${thoughtId}`);
  return getDoc(docRef).then(doc => {
    if(doc.exists()){
      return {...doc.data(), id: doc.id, date: doc.data().date.toDate()};
    }else{
      throw new Error("There is no doc with id of " + thoughtId + " for user")
    }
  })
}

function updateThought(userId,thoughtId, thoughtObj){
  const docRef = doc(db,`users/${userId}/thoughts/${thoughtId}`);
  return setDoc(docRef, thoughtObj);
}

export{
  auth, 
  onAuthStateChanged,
  signOut,
  signInWithEmailAndPassword, 
  /*ui, uiConfig,*/ 
  getUserDocument,
  createUserDocumentWithIdAndEmail,
  getThoughtsForUser,
  insertThought,
  getThought,
  updateThought
}



